import { ApolloProvider } from "@apollo/client";
import { Layer } from "@carbon/react";
import {
  AuthModeProvider,
  ImportExportAuthGuard,
  InternationalizationProvider as ImportExportInternationalizationProvider,
  JobDetailsPage,
} from "@flaminem/import-export";
import { useParams } from "react-router-dom";

import { AppUser } from "src/authentication/appUser.ts";
import PageHeader from "src/components/PageHeader.tsx";
import PageStack from "src/components/PageStack/PageStack.tsx";
import { getImportExportApolloClient } from "src/graphql/import-export/apolloClient.ts";
import { useLocale, useT } from "src/internationalization";

export const JobsDetailPage = () => {
  const { jobId } = useParams<{ jobId: string }>();
  const { locale } = useLocale();
  const t = useT();

  if (!jobId) {
    return <div>Dashboard ID is required</div>;
  }

  return (
    <ApolloProvider client={getImportExportApolloClient()}>
      <AuthModeProvider authMode="bearer">
        <ImportExportAuthGuard getToken={() => AppUser.getAccessToken() ?? null}>
          <ImportExportInternationalizationProvider locale={locale}>
            <PageStack>
              <PageHeader className="mb-5">{t("import.jobs.title")}</PageHeader>
              <Layer level={1}>
                <JobDetailsPage jobId={jobId} />
              </Layer>
            </PageStack>
          </ImportExportInternationalizationProvider>
        </ImportExportAuthGuard>
      </AuthModeProvider>
    </ApolloProvider>
  );
};
